<p-overlayPanel #op styleClass="shadow-md border-round-xl ">
    <ng-template pTemplate="content">
        <div class="border-bottom-1 surface-border flex align-items-center gap-2 w-19rem h-5rem px-3">
            <div>
                <span
                    class="border-circle flex justify-content-center border-circle align-items-center width-32 heigth-32 text-semibold text-primary-300 bg-primary-400"
                    >{{ this.userInfo?.logo }}</span
                >
            </div>
            <div>
                <p class="text-color m-0 text-medium">{{ this.userInfo?.displayName }}</p>
                <p class="text-gray-300 m-0 text-sm">{{ this.userInfo?.username }}</p>
            </div>
        </div>
        <p-button
            styleClass="border-none w-full text-left h-3rem border-round-bottom-lg text-red-500"
            label="Log out"
            [loading]="loading"
            icon="pi pi-power-off"
            [outlined]="true"
            (onClick)="userLogOut()"
        >
        </p-button>
    </ng-template>
</p-overlayPanel>
<p-button
    (click)="toggle(op, $event)"
    class="user-info-button"
    [icon]="icon"
    iconPos="right"
    [text]="true"
    label="name"
    styleClass="p-1 border-round-lg	 gap-2 hover:surface-hover focus:surface-hover border-none"
    [outlined]="true"
>
    <ng-template pTemplate="content">
        <span
            class="border-circle flex justify-content-center align-items-center width-32 heigth-32 text-semibold border-circle text-primary-300 bg-primary-400"
            >{{ this.userInfo?.logo }}</span
        >
        <p class="text-color pl-2 m-0">{{ this.userInfo?.displayName }}</p>
    </ng-template>
</p-button>
